import { useQuery } from '@tanstack/react-query';

import { Subscriptions } from '@air/api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

const SUBSCRIPTIONS_LIST_PLANS = 'SUBSCRIPTIONS_LIST_PLANS';

export const getSubscriptionPlansListKey = (workspaceId?: string) => {
  return workspaceId ? [SUBSCRIPTIONS_LIST_PLANS, { workspaceId }] : [SUBSCRIPTIONS_LIST_PLANS];
};

export const usePlansList = () => {
  const { currentWorkspace } = useCurrentWorkspace();

  return useQuery({
    queryKey: getSubscriptionPlansListKey(),

    queryFn: async () => {
      const workspaceId = currentWorkspace?.id;

      if (!workspaceId) {
        throw new Error('No workspace id');
      }
      const result = await Subscriptions.listPlans({ workspaceId });

      return result;
    },
    enabled: !!currentWorkspace?.id,
  });
};
